/* Craft film — tap the poster to play.

   The video ships preload="none", so until someone taps there is no request
   for it at all: a film nobody watches costs nobody any data. The poster comes
   from video_tag, which takes it from the video's own preview frame.

   Native controls are left on. A craft film is watched, scrubbed and
   abandoned like any other video, and a bespoke control bar would only be a
   worse version of the one the phone already has. */

/* ⚠ WRAPPED, BECAUSE THIS FILE IS INCLUDED ONCE PER FILM. A product with
   two films gets two script tags, and a top-level `class` declaration throws
   "Identifier 'CraftFilm' has already been declared" on the second — before
   the customElements guard below it can run. Inside a function the binding is
   local, so a second copy returns quietly, the element having been already
   defined by the first copy. */
(function () {
  if (customElements.get('craft-film')) return;

class CraftFilm extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('[data-craft-film-play]');
    this.poster = this.querySelector('.craft-film__poster');
    if (!this.video || !this.button) return;

    /* The frame is a link to the product and the button sits on top of it.
       A click on the button must not also follow the link, or every attempt to
       play would navigate away instead — which looks exactly like "it does not
       play". */
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.start();
    });

    // If playback begins any other way — the native control, a keyboard, the
    // OS media keys — the overlay has no business still sitting there.
    this.video.addEventListener('play', () => this.reveal());
    // Paused or finished, the card comes back — it is how someone buys the
    // thing they have just watched.
    this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
    this.video.addEventListener('ended', () => this.classList.remove('is-playing'));
  }

  reveal() {
    this.button.hidden = true;
    // The overlay sits where the native scrubber appears, so it stands down
    // once there is something to scrub.
    this.classList.add('is-playing');
    if (this.poster) this.poster.hidden = true;
    // Hand over to the platform's own control bar now there is something to
    // scrub. Before play it would have been a second thing to press.
    this.video.controls = true;
  }

  start() {
    this.reveal();
    const played = this.video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(() => {
        // Autoplay policy, a codec the browser will not take, a file that has
        // gone missing. Put the affordance back rather than leaving a dead
        // black rectangle with nothing to press.
        this.button.hidden = false;
        if (this.poster) this.poster.hidden = false;
        this.video.controls = false;
        this.classList.remove('is-playing');
      });
    }
  }
}

  customElements.define('craft-film', CraftFilm);
})();
